import React from 'react'
import { Row, Col, Divider } from 'antd'
import IntlMessages from '../util/IntlMessages'
import _ from 'lodash'
import {
  isEmptyObject,
  getDecryptID,
  formatDigits,
  customParse,
  parseFloatCustom,
  parseIntCustom,
  fetchCurrentSalesOrder
} from '../appRedux/actions/GlobalMethods'
import Barcode from 'react-barcode'
import moment from 'moment'
import {
  PRINT_CONST_FOOTER_1,
  PRINT_CONST_FOOTER_2
  // REACT_APP_PRINT_CONST_FOOTER_3
} from '../constants/StoreSetting'
import { env } from '../env'

const { REACT_APP_PRINT_CONST_FOOTER_3 } = env

export class ZeeReport extends React.PureComponent {
  render () {
    const {
      outletName,
      registerName,
      showRefID,
      showSaleTax,
      showSaleDate,
      showTotalAmount,
      showTotalTax
    } = this.props
    const decimal = this.props.decimal ? this.props.decimal : 2
    const data = this.props.data ? this.props.data : false
    const currData = this.props.currData
      ? this.props.currData
      : {
          currencyCode: ''
        }
    const today = moment().format('LLLL')
    return (
      <>
        {data ? (
          <div className='custom-print-outer-layout'>
            <div>
              {data.outletName && data.outletName != '' && (
                <Row justify='center'>
                  <Col>
                    <h2 className='reciept-font-size'>
                      <strong>{data.outletName}</strong>
                    </h2>
                  </Col>
                </Row>
              )}
              {data.registerName && data.registerName != '' && (
                <Row justify='center'>
                  <Col>
                    <h2 className='reciept-font-size'>
                      <strong>{data.registerName}</strong>
                    </h2>
                  </Col>
                </Row>
              )}
              <Row justify='center'>
                <Col>
                  <h3 className='reciept-font-size'>{today}</h3>
                </Col>
              </Row>

              <Divider dashed={true} style={{ backgroundColor: 'black' }} />

              <Row justify='center'>
                {/* showRefID */}
                {true && (
                  <Col span={8}>
                    {/* <h3 className='reciept-font-size'>Ref ID</h3> */}
                  </Col>
                )}

                <Col span={8}>
                  <h3
                    style={{ textAlign: 'center' }}
                    className='reciept-font-size'
                  >
                    Amount
                  </h3>
                </Col>

                {/* showSaleTax */}
                {showSaleDate && (
                  <Col span={8}>
                    <h3
                      style={{ textAlign: 'center' }}
                      className='reciept-font-size'
                    >
                      Date
                    </h3>
                  </Col>
                )}
              </Row>
              {data && data.sales && data.sales.length > 0 ? (
                data.sales.map((e, key) => {
                  return (
                    <>
                      <div key={key}>
                        <Row justify='center'>
                          {/* showRefID */}
                          {true && (
                            <Col span={8}>
                              <h3 className='reciept-font-size'>
                                {e.refID ? `${getDecryptID(e.refID)}` : ''}
                              </h3>
                            </Col>
                          )}

                          <Col span={8}>
                            {e.payments &&
                              e.payments.map((qwe, key) => {
                                let lkey = key + 1
                                return (
                                  <>
                                    <h3
                                      style={{ textAlign: 'center' }}
                                      className='reciept-font-size'
                                    >
                                      {`${qwe.paymentTypeName} `}
                                      {qwe.amount
                                        ? `${currData.currencySymbol} ${
                                            qwe.amount
                                          } ${
                                            getDecryptID(
                                              e.salesOrderStatusID
                                            ) ===
                                            getDecryptID(
                                              fetchCurrentSalesOrder('Voided')
                                            )
                                              ? '(Void)'
                                              : ''
                                          }`
                                        : ''}
                                    </h3>
                                    {e.payments.length == lkey && <br />}
                                  </>
                                )
                              })}

                            {e.payments.length > 1 && (
                              <>
                                <Divider />
                                <h5
                                  style={{ textAlign: 'center' }}
                                  className='reciept-font-size'
                                >
                                  TOTAL
                                </h5>
                                <h3
                                  style={{ textAlign: 'center' }}
                                  className='reciept-font-size'
                                >
                                  {e.amountList
                                    ? `${currData.currencySymbol} ${e.amountList}`
                                    : ''}
                                </h3>
                              </>
                            )}

                            {/* <h3
                              style={{ textAlign: 'center' }}
                              className='reciept-font-size'
                            >
                              {e.amount
                                ? `${currData.currencySymbol} ${e.amount} ${
                                    getDecryptID(e.salesOrderStatusID) ===
                                    getDecryptID(
                                      fetchCurrentSalesOrder('Voided')
                                    )
                                      ? '(Void)'
                                      : ''
                                  }`
                                : ''}
                            </h3> */}
                          </Col>

                          {showSaleDate && (
                            <Col span={8}>
                              <h3
                                style={{ textAlign: 'end' }}
                                className='reciept-font-size'
                              >
                                {moment(e.date).format('l LT')}
                                {/* {e.tax
                                  ? `${currData.currencySymbol} ${e.tax}`
                                  : ''} */}
                              </h3>
                            </Col>
                          )}
                        </Row>
                        {/* {showSaleDate && (
                          <Row justify='center' style={{ marginTop: -18 }}>
                            <Col>
                              <h3 style={{ fontSize: 28, color: '#000' }}>
                                {moment(e.date).format('l LT')}
                              </h3>
                            </Col>
                          </Row>
                        )} */}
                        {key < data.sales.length - 1 && <Divider />}
                      </div>
                    </>
                  )
                })
              ) : (
                <div>
                  <Row justify='center'>
                    <Col>
                      <h4
                        className=''
                        style={{ margin: 36, fontSize: 35, color: '#000' }}
                      >
                        There are no sales
                      </h4>
                    </Col>
                  </Row>
                </div>
              )}
              {data &&
              data.sales &&
              data.sales.length > 0 &&
              data.totalPayments &&
              data.totalPayments.length > 0 ? (
                <>
                  <Divider dashed={true} style={{ backgroundColor: 'black' }} />
                  {data.totalPayments.map(qaq => {
                    return (
                      <Row justify='start'>
                        <Col span={12}>
                          <h3
                            className='reciept-font-size'
                            style={{ textAlign: 'start' }}
                          >
                            Total {qaq.paymentName}:
                          </h3>
                        </Col>

                        <Col span={12}>
                          <h3
                            className='reciept-font-size'
                            style={{ textAlign: 'start' }}
                          >
                            {`${currData.currencySymbol} ${qaq.total}`}
                          </h3>
                        </Col>
                      </Row>
                    )
                  })}
                </>
              ) : (
                <></>
              )}
              {data && data.sales && data.sales.length > 0 ? (
                <>
                  <Divider dashed={true} style={{ backgroundColor: 'black' }} />
                  {data.totalAmount && showTotalAmount ? (
                    <Row justify='start'>
                      <Col span={12}>
                        <h3
                          className='reciept-font-size'
                          style={{ textAlign: 'start' }}
                        >
                          Total Amount:
                        </h3>
                      </Col>

                      <Col span={12}>
                        <h3
                          className='reciept-font-size'
                          style={{ textAlign: 'start' }}
                        >
                          {/* {`${currData.currencySymbol} ${data.totalAmount}`} */}
                          {`${currData.currencySymbol} ${data.totalAmountPayList}`}
                        </h3>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {/* showTotalTax */}
                  {data.totalTax && false ? (
                    <Row justify='start'>
                      <Col span={12}>
                        <h3 className='reciept-font-size'>Total Tax:</h3>
                      </Col>

                      <Col span={12}>
                        <h3
                          // style={{ float: "right", marginRight: "2px" }}
                          className='reciept-font-size'
                        >
                          {`${currData.currencySymbol} ${data.totalTax}`}
                        </h3>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {data.totalVoid ? (
                    <Row justify='start'>
                      <Col span={12}>
                        <h3 className='reciept-font-size'>Total Void</h3>
                      </Col>

                      <Col span={12}>
                        <h3
                          // style={{ float: "right", marginRight: "2px" }}
                          className='reciept-font-size'
                        >
                          {`${currData.currencySymbol} ${data.totalVoid}`}
                        </h3>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}

              <div style={{ marginTop: 32 }}>
                <h2
                  className='reciept-font-size'
                  style={{ textAlign: 'center' }}
                >
                  <strong>{PRINT_CONST_FOOTER_1}</strong>
                </h2>
                <h3
                  className='reciept-font-size'
                  style={{ textAlign: 'center' }}
                >
                  {PRINT_CONST_FOOTER_2}
                </h3>
                <h3
                  className='reciept-font-size'
                  style={{ textAlign: 'center' }}
                >
                  {REACT_APP_PRINT_CONST_FOOTER_3}
                </h3>
              </div>
            </div>
          </div>
        ) : (
          <h1>
            <IntlMessages id='sell.openclose.connectionlost' />
          </h1>
        )}
      </>
    )
  }
}
